import { createEffect, sample } from 'effector';
import $$api from 'models/api';
import { $global } from 'models/store-global';

import AlertsService from 'services/AlertsService';

import { MyStore, TRole } from 'types/Store';

sample({
    clock: [
        $$api.termsAndConditions.loadRelevantFx.failData,
        $$api.termsAndConditions.isRelevantSignedFx.failData,
        $$api.termsAndConditions.signRelevantFx.failData,
    ],
    target: createEffect(AlertsService.handleError),
});

// Handle loadRelevant success
sample({
    source: $global,
    clock: $$api.termsAndConditions.loadRelevantFx.done.map(({ params: role, result }) => ({ role, result })),
    fn: (store, { role, result }): MyStore => ({
        ...store,
        tac: {
            ...(store.tac || { user: {} }),
            [role]: {
                ...(store.tac?.[role] || {}),
                htmlContent: result,
            },
        },
    }),
    target: $global,
});

// Handle isRelevantSigned success
sample({
    source: $global,
    clock: $$api.termsAndConditions.isRelevantSignedFx.done.map(({ params: role, result: { isRelevantSigned } }) => ({
        role,
        isRelevantSigned,
    })),
    fn: (store, { role, isRelevantSigned }): MyStore => ({
        ...store,
        tac: {
            ...(store.tac || {}),
            [role as TRole]: {
                ...(store.tac?.[role as TRole] || {}),
                isRelevantSigned: isRelevantSigned,
            },
        },
    }),
    target: $global,
});

// Handle signRelevant success
sample({
    source: $global,
    clock: $$api.termsAndConditions.signRelevantFx.done.map(({ params: role }) => role),
    fn: (store, role): MyStore => ({
        ...store,
        tac: {
            ...(store.tac || {}),
            [role]: {
                ...(store.tac?.[role] || {}),
                isRelevantSigned: true,
            },
        },
    }),
    target: $global,
});
